const SUPPORT_DECISION_TYPES = new Set([
  "answer",
  "answer_with_links",
  "navigate",
  "catalog_recommendation",
  "diagnostic_summary",
  "setup_guidance",
]);

export function shouldShowInteractionDecisionCard({ decision, hasExecutionPreview = false } = {}) {
  if (!decision || !hasExecutionPreview) return false;
  const decisionType = String(decision.decision_type || "");
  const interactionMode = String(decision.interaction_mode || "");
  if (interactionMode === "execution_request" || interactionMode === "workflow_orchestration") {
    return false;
  }
  if (decisionType === "clarification_required") {
    return interactionMode === "clarification_needed";
  }
  return SUPPORT_DECISION_TYPES.has(decisionType);
}

export function shouldShowExecutionPreviewCard({ message } = {}) {
  const metadata = message?.metadata || {};
  if (!metadata.execution_preview || metadata.preview_confirmed) return false;
  return message?.status === "preview";
}
